import { useMutation } from '@apollo/client';
import { validate as uuidValidate } from 'uuid';
import { useDispatch } from 'react-redux';

import ReactTable from '../../components/react_table/react_table';

import { picklistProductDelete as picklistProductDeleteMutation } from '../../graphql/picklist_product_queries';
import { toastSuccess, toastWarning, toastError } from '../../lib/toast_helpers';
import { settingsSet } from '../../store/settings_slice';
import * as updateFunctions from '../../update_functions';

const PicklistProductList = (props) => {
  const {
    currentUser,
    picklistProducts,
    settingsTenant,
    settingsOnline,
    onDelete,
    onEdit,
  } = props;

  const dispatch = useDispatch();
  const [picklistProductDelete] = useMutation(picklistProductDeleteMutation);

  const picklistProductEditClicked = (picklistProductId) => {
    onEdit(picklistProductId);
  };

  const picklistProductDeleteClicked = async (e) => {
    const dataId = e.currentTarget.getAttribute('data-id');
    const picklistProductId = uuidValidate(dataId)
      ? dataId
      : parseInt(e.currentTarget.getAttribute('data-id'), 10);
    const mutationData = {
      variables: { id: picklistProductId },
      context: {
        serializationKey: settingsTenant,
        tracked: true,
        recordType: 'PicklistProductType',
        recordId: picklistProductId,
        mutationType: 'DELETE',
      },
      update: updateFunctions.picklistProductDelete,
    };
    mutationData.optimisticResponse = updateFunctions.optimisticNew({
      mutationName: 'picklistProductDelete',
      mutationData,
    });
    dispatch(
      settingsSet({
        mutating: true,
      })
    );
    if (settingsOnline) {
      try {
        await picklistProductDelete(mutationData);
        toastSuccess('Product Assembly Link delete ok');
      } catch (err) {
        console.log(err.toString());
        toastError('Product Assembly Link delete failed');
      } finally {
        dispatch(
          settingsSet({
            mutating: false,
          })
        );
        onDelete();
      }
    } else {
      picklistProductDelete(mutationData);
      toastWarning(
        `Product Assembly Link delete ok locally. Go online to make permanent`
      );
      dispatch(
        settingsSet({
          mutating: false,
        })
      );
      onDelete();
    }
  };

  const getProductName = (row) => {
    const {
      product: { name: productName },
    } = row;
    return productName;
  };

  const parentColumns = [
    {
      header: 'Product Assembly',
      id: 'product',
      accessorFn: (row) => getProductName(row),
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      header: 'Quantity',
      accessorKey: 'quantity',
      // accessorFn: (row) => getProductName(row),
      // enableColumnFilter: true,
      // filterFn: 'includesString',
    },
  ];

  return (
    <ReactTable
      rootName="picklistProduct"
      parentColumns={parentColumns}
      data={picklistProducts}
      doShow={false}
      handleEdit={picklistProductEditClicked}
      doDelete={currentUser?.perms?.administrator}
      handleDelete={picklistProductDeleteClicked}
    />
  );
};

export default PicklistProductList;
